import React from "react"
import styled from "styled-components"
import moment from "moment"

import { InlineList, InlineListItem } from "components/box"
import { ParagraphSmall, Paragraph } from "components/text"
import { ConsultationFragmentConsultationMessages } from "typings/types"
import { Separator } from "components/separator"

const List = styled(InlineList)`
  display: block;
  margin: 0;
  text-align: left;
`

const ListItem = styled(InlineListItem)`
  display: block;
  padding: 0;
`

const Date = styled(ParagraphSmall)`
  font-weight: bold;
  letter-spacing: 1.75px;
  margin-bottom: ${props => props.theme.space[4]}
  color: ${props => props.theme.colors.seafoamBlue}
`

const DATE_FORMAT = "MM/DD/YYYY HH:mm"

type Props = {
  messages: ConsultationFragmentConsultationMessages[]
}

const MessageList = ({ messages }: Props) => (
  <List>
    {messages.map(({ id, body, authorName, createdAt, authorType }, index) => (
      <ListItem key={id}>
        <Date>{moment.utc(createdAt, DATE_FORMAT).local().format(DATE_FORMAT)}</Date>
        <Paragraph bold mb={1}>
          {authorType === "doctor" ? "Dr." : ""} {authorName}
        </Paragraph>
        <Paragraph whiteSpace="pre-wrap">{body}</Paragraph>
        {messages.length !== index + 1 && <Separator borderColor="silver" my={5} />}
      </ListItem>
    ))}
  </List>
)

export default MessageList
